import { render, staticRenderFns } from "./TrustedLabel.vue?vue&type=template&id=66073acf&scoped=true&functional=true&"
import script from "./TrustedLabel.vue?vue&type=script&lang=ts&"
export * from "./TrustedLabel.vue?vue&type=script&lang=ts&"
import style0 from "./TrustedLabel.vue?vue&type=style&index=0&id=66073acf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "66073acf",
  null
  
)

export default component.exports